/**************************************************
 * Nombre:       Formulario_Modulo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {BadgeOutlined} from '@mui/icons-material'
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTextoLista from "../../../Modulo_formularios/Componentes/IngresoTextoLista";

const Formulario_Modulo = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Titulo del Modulo'} dato={'nombre'} {...props}
                                  ejemplo={'Modulo Básico ( 60 horas )'}
                    />
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoLista nombre={'Items'} dato={'item'} {...props}  />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Modulo